import get from 'lodash/get';
import classNames from 'classnames';
import React, {Component} from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import {generateNextRowId} from '../../../services/idHelpers';
import MinusButton from './MinusButton';
import PlusButton from './PlusButton';
import UpButton from './UpButton';
import DownButton from './DownButton';
import Error from '../../Error';
import TooltipIcon from '../../TooltipIcon';
import DraggableCell from './DraggableCell';
import DraggableRow from './DraggableRow';
import DragDropTableBody from './DragDropTableBody';

class LabelsType extends Component {
    constructor(props) {
        super(props);
        this.addRow = this.addRow.bind(this);
    }

    addRow() {
        const rows = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextRowId(rows), minLabel: '', maxLabel: ''});
    }

    render() {
        const {remove, move, form, name} = this.props;

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col />
                    <col style={{width: 80}} />
                    <col style={{width: 80}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.id} /></th>
                        <th>
                            <FormattedMessage {...messages.surveys.form.label.minLabel} />
                            {' '}
                            <TooltipIcon message={messages.surveys.form.tooltip.multipleNumber1.minLabel} />
                        </th>
                        <th>
                            <FormattedMessage {...messages.surveys.form.label.maxLabel} />
                            {' '}
                            <TooltipIcon message={messages.surveys.form.tooltip.multipleNumber1.maxLabel} />
                        </th>
                        <th />
                    </tr>
                </thead>
                <DragDropTableBody move={move}>
                    {get(form.values, name) && get(form.values, name).map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField id={`${name}.${index}.id`} name={`${name}.${index}.id`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.minLabel`} name={`${name}.${index}.minLabel`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.minLabel`) && get(form.touched, `${name}.${index}.minLabel`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.minLabel`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.maxLabel`} name={`${name}.${index}.maxLabel`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.maxLabel`) && get(form.touched, `${name}.${index}.maxLabel`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.maxLabel`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell className="border-right">
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <div className="">{index > 0 && <UpButton move={move} index={index} />}</div>
                                        <div className="">{index + 1 < arr.length && <DownButton move={move} index={index} />}</div>
                                    </div>
                                </div>
                            </DraggableCell>
                            <DraggableCell>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={this.addRow}>
                                <FormattedMessage {...messages.surveys.button.add_row} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}

export default LabelsType;
